import React from "react";

const MieszkaniecWspolnota = props => {

    const { wspolnota, wazneNumery } = props;

    const numery = wazneNumery && wazneNumery?.length > 0 && wazneNumery?.map( (numer, i) => {

        return (
            <li 
                key={i}
                style={{margin: "0", padding: "2px 10px"}}    
            >
                {`${numer?.numer}: ${numer?.opis}`}
            </li>
        )
    })

    return (
        <div className="lista ramka-br ramka-border-shadow">
            <h3>
                {wspolnota?.name}
            </h3>
            <div>
                <h4>
                    Ważne numery
                </h4>
                {
                    numery && numery?.length > 0 && (
                        <ul className="lista mieszkaniecDane">
                            {numery}
                        </ul>
                    )
                }
            </div>
        </div>

    )
}

export default MieszkaniecWspolnota;